"use client";
import { createContext, useContext } from "react";
const ToolbarContext = /*#__PURE__*/ createContext(null);
function useToolbarContext() {
    const context = useContext(ToolbarContext);
    return context ?? {};
}
export { ToolbarContext, useToolbarContext };
